module.exports = __webpack_public_path__ + "img/36.53c90e92.jpg";